/* eslint-disable */
export const loadGooglePlacesApi = (callback) => {
  const apiKey = process.env.REACT_APP_LOCATION_API_KEY;
  const loader = document.createElement('script');
  loader.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&libraries=places&callback=initPlaces`;
  loader.setAttribute('async', '');
  loader.setAttribute('id', 'google-places-api');
  document.querySelector('head').appendChild(loader);
  window.initPlaces = callback;
};
/* eslint-enable */
